import classNames from "classnames/bind";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";
import { useStoreContext } from "../../../hooks/useStoreContext";
import axiosClient from "../../../services/axiosClient";
import { actions } from "../../../store";
import InputText from "../../Register/FormRegister/InputText";
import HeaderRegister from "../../Register/HeaderRegister";
import styles from './ForgotPassword.module.css';
import { Loading } from "../../../components";

const cx = classNames.bind(styles)

function ForgotPasswordContainer({ getError }) {
    const [emailForgot, dispatch] = useStoreContext()
    // eslint-disable-next-line
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const onChangeEmail = (data) => {
        dispatch(actions.setEmailForgotPassword(data))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const getCode = async () => {
            setIsLoading(true)
            try {
                const res = await axiosClient.post('/authenticator/password-reset/require',
                    { email: emailForgot.emailForgotPassword })
                setIsLoading(false)
                navigate('/forgot-password/verify-token')
                return res
            } catch (error) {
                if (emailForgot?.emailForgotPassword?.trim()?.length === 0) {
                    getError("Địa chỉ Email không được bỏ trống")
                } else {
                    getError("Tài khoản chưa được kích hoạt")
                }
                setIsLoading(false)
            }
        }
        getCode()
    }
    return (
        <>
            <HeaderRegister header={'Quên mật khẩu'} backTo={'/login'} />
            <form className={cx('form-get-email')} onSubmit={e => handleSubmit(e)}>
                <InputText
                    title={'Email'}
                    name={'EMAIL'}
                    error={error}
                    value={emailForgot.emailForgotPassword}
                    onChange={onChangeEmail}
                    row
                    register
                    placeholder={'Nhập'}
                />
                <button className={cx('button-submit')} type={'submit'}>
                    <Button
                        title="Tiếp tục"
                        onClick={e => (e)}
                    />
                </button>
            </form>
            {isLoading && <div className={cx('loading')}><Loading /></div>}
        </>
    )
}

export default ForgotPasswordContainer;